/** ***********
*
* <inflator.interceptor.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { inflate } from 'pako';
import { ApiBuffer } from '../models/utils';

export const INFLATE = new HttpContextToken<boolean>(() => false);

@Injectable()
export class InflatorInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse
          && event.body?.type === 'Buffer'
          && request.context.get(INFLATE)
        ) {
          return event.clone({ body: JSON.parse(inflate((event.body as ApiBuffer).data, { to: 'string' })) });
        }
        return event;
      })
    );
  }
}
